// extracted by mini-css-extract-plugin
export default {"root":"pricingConfig_root__EJNYj","main_container":"pricingConfig_main_container__XoVfl","costProfile":"pricingConfig_costProfile__qof9Z","table":"pricingConfig_table__GNgWq"};